const VERSION_DATA_CENTER = "base-platform/v2"

// 动态查看访客申请详情
export const openAutoInfo = {
  url: `/${VERSION_DATA_CENTER}/base/visitor/open/auto/info`,
}

// 访客配置查看

// 外部
export const openConfInfo = {
  url: `/${VERSION_DATA_CENTER}/base/visitor/open/conf/info`,
}

// 老师
export const teacherAppInfo = {
  url: `/${VERSION_DATA_CENTER}/base/visitor/application/teacher/app/info`,
}

// 家长
export const parentAppInfo = {
  url: `/${VERSION_DATA_CENTER}/base/visitor/application/parent/app/auto/info`,
}

// 访问类型列表
export const openDictionary = {
  url: `/${VERSION_DATA_CENTER}/base/visitor/open/dictionary`,
}

// 新增访客申请
export const openSave = {
  url: `/${VERSION_DATA_CENTER}/base/visitor/open/save`,
  method: "POST",
}
export const parentAppSave = {
  url: `/${VERSION_DATA_CENTER}/base/visitor/application/parent/app/save`,
  method: "POST",
}
export const teacherAppSave = {
  url: `/${VERSION_DATA_CENTER}/base/visitor/application/teacher/app/save`,
  method: "POST",
}

// 修改访客申请
export const openChange = {
  url: `/${VERSION_DATA_CENTER}/base/visitor/open/change`,
  method: "POST",
}

// 查看学校访客申请列表
export const openPage = {
  url: `/${VERSION_DATA_CENTER}/base/visitor/open/page`
}

export const teacherAppPage = {
  url: `/${VERSION_DATA_CENTER}/base/visitor/application/teacher/app/page`
}

export const parentAppPage = {
  url: `/${VERSION_DATA_CENTER}/base/visitor/application/parent/app/page`
}

// 访客搜索被仿人
export const visitorOpenTeacher = {
  url: `/${VERSION_DATA_CENTER}/base/visitor/open/teacher`
}

// 老师审批结果回调
export const teacherAppCallback = {
  url: `/${VERSION_DATA_CENTER}/base/visitor/application/teacher/app/callback`,
  method: "POST",
}

// 检查是否有历史数据 外部
export const openCheckHistory = {
  url: `/${VERSION_DATA_CENTER}/base/visitor/open/check/history`
}

// 检查是否有历史数据 家长
export const parentCheckHistory = {
  url: `/${VERSION_DATA_CENTER}/base/visitor/application/parent/app/check/history`
}

